module.exports = __webpack_public_path__ + "img/ca0d5bd33d6874fba85d32c875d5d807.png";